import animateScrollTo, { IOptions } from 'animated-scroll-to';

export const scrollToTop = (): void => {
    animateScrollTo(0, {
        elementToScroll: document.getElementById('root-seciton')
    });
};

export const scrollToElement = (element: HTMLElement, yOffset = 0, userOptions?: any): void => {
    if (!element) { return; }

    let options: any = {
        elementToScroll: document.getElementById('root-seciton'),
        verticalOffset: yOffset
    };

    if (['xs', 'sm'].includes(document.body.getAttribute('screen-size'))) {
        options.elementToScroll = document.getElementById('root-seciton')
    }

    if (userOptions) {
        options = { 
            ...options,
            ...userOptions
        }
    }

    animateScrollTo(element, options);
};
